//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SidebarLeft',
  data() {
    return {
      time: null,
      pendingNavigation: null,
    }
  },

  computed: {
    isOpen: {
      get() {
        return this.$store.state.leftSidebarOpen
      },
      set(value) {
        this.$store.commit('openLeftSidebar', value)
      },
    },

    sections() {
      const globals = this.$store.state.globals_new

      if (!Array.isArray(globals)) return []

      return globals
          .filter(section => section.handle?.includes('hamburger'))
          .map(section => {
            const items = Array.isArray(section.items) ? section.items : []

            const links = items
                .filter(link => {
                  if (!link.active) return false
                  if (link.visibility === 'auth' && !this.user) return false
                  return true
                })
                .slice()
                .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))

            return {
              handle: section.handle,
              title: section.title || '',
              links,
            }
          })
    }
  },

  beforeDestroy() {
    if (process.client) {
      document.body.style.overflow = ''
    }
  },

  watch: {
    isOpen(value) {
      if (process.client) {
        document.body.style.overflow = value ? 'hidden' : ''
      }
    }
  },

  created() {
    this.getNow()
    setInterval(this.getNow, 1000)
  },

  methods: {
    normalizeUrl(url) {
      if (!url || url.startsWith('http')) return url
      return url.endsWith('/') ? url : `${url}/`
    },

    handleAction(link) {
      if (typeof this[link.action] === 'function') {
        this[link.action]()
      }
      this.close()
    },

    openSettings() {
      this.$modal.show('modal-settings')
      this.close()
    },

    handleNuxtLink(link) {
      this.pendingNavigation = this.normalizeUrl(`/${link.url}`)
      this.close()
    },

    onAfterLeave() {
      if (!this.pendingNavigation) return
      const target = this.pendingNavigation
      this.pendingNavigation = null
      const pushResult = this.$router.push(target)

      if (process.client) {
        document.body.style.overflow = ''
      }

      if (pushResult && typeof pushResult.catch === 'function') {
        pushResult.catch((err) => {
          if (err.name !== 'NavigationDuplicated') console.warn(err)
        })
      }
    },

    getNow() {
      this.time = this.$date().format('FF')
    },

    close() {
      this.$store.commit('openLeftSidebar', false)
    },
  },
}
